module.exports = __webpack_public_path__ + "assets/raleigh-sales-recruiters-1.32936425.png";